import { SButton, SButtonContainer, SCheckbox, SDialogButton, SIconButton, SInputLabel, STitleContainer, STitleH3 } from '../common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import { RiAddFill } from 'react-icons/ri';
import { FaMinusCircle, FaSearch, FaTrash } from 'react-icons/all';
import { HeadCell, Order, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import { CooperativaDTO, UserDTO, UserRole } from '../common/Dtos';
import { FormControl, FormControlLabel, Grid, MenuItem, Select, Table, TableBody, TableContainer, TextField } from '@material-ui/core';
import { toast } from 'react-toastify';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import { useHistory } from 'react-router-dom';
import AuthContext from '../auth/AuthContext';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AlertDialogContext } from '../common/AlertDialog';

export function Operatori() {
	const auth = useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const history = useHistory();
	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);
	const classes = useStyles();

	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('name');
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(25);
	const [totalRow, setTotalRow] = useState(5);
	const [selected, setSelected] = useState<string[]>([]);
	const [operatoreFilter, setOperatoreFilter] = useState<string>('');
	const [activatedFilter, setActivatedFilter] = useState<boolean>(true);
	const [cooperativaFilter, setCooperativaFilter] = useState<string>('ALL');
	const [operatoreList, setOperatoreList] = useState<UserDTO[]>([]);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [deleteModalMessage, setDeleteModalMessage] = useState('');
	const [cooperativeList, setCooperativeList] = useState<CooperativaDTO[]>([]);
	const [isDelete, setIsDelete] = useState(false);

	const headCells: HeadCell[] = [
		{id: 'firstname', numeric: false, disablePadding: true, label: 'NOME', sortable: true},
		{id: 'lastname', numeric: false, disablePadding: true, label: 'COGNOME', sortable: true},
		{id: 'email', numeric: false, disablePadding: true, label: 'eMAIL', sortable: true},
		{id: 'telefono', numeric: false, disablePadding: true, label: 'TELEFONO', sortable: true},
		{id: 'cooperativa', numeric: false, disablePadding: true, label: 'COOPERATIVA', sortable: true},
		{id: 'action', numeric: false, disablePadding: false, label: '', sortable: false}
	];

	useEffect(() => {
		getOperatori();
	}, [selected, orderBy, order, page, rowsPerPage]);

	useEffect(() => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			getCooperative();
		}
	}, [operatoreList]);

	const getCooperative = () => {
		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0) {
			auth.state.axiosInstance?.get('/api/cooperativa/listall')
				.then(res => {
					setCooperativeList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero delle Prestazioni!');
					console.log(error);
				})
		}
	}

	const getOperatori = () => {
		const qs = require('qs');
		auth.state.axiosInstance?.get('/api/accounts/operatori_by_cooperativa_first_or_last_name', {
			params: {
				nomeOrCognome: operatoreFilter,
				activatedOnly: activatedFilter,
				cooperativa: cooperativaFilter === 'ALL' ? '' : cooperativaFilter,
				page: page,
				size: rowsPerPage,
				sort: orderBy + ',' + order
			},
			paramsSerializer: params => {
				return qs.stringify(params)
			}
		})
			.then(res => {
				setOperatoreList(res.data.content);
				setTotalRow(res.data.totalElements);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero degli Operatori!');
				console.log(error);
			})
	};

	const handleNewOperatore = () => {
		history.push("/dettaglio/operatore");
	};

	const handleDisattivaSelezionati = () => {
		setIsDelete(false);
		setDeleteModalMessage('Sei sicuro di voler procedere con la disattivazione?');
		if (selected.findIndex((id) => id === auth.state.id) !== -1) {
			setDeleteModalMessage('E\' stato selezionato l\'utente attualmente autenticato, questo non verra\' disattivato. \n Sei sicuro di voler procedere con la cancellazione?');
		}
		setDeleteModalVisible(true);
	}

	const handleEliminaSelezionati = () => {
		setIsDelete(true);
		setDeleteModalMessage('Sei sicuro di voler procedere con la cancellazione?');
		if (selected.findIndex((id) => id === auth.state.id) !== -1) {
			setDeleteModalMessage('E\' stato l\'utente attualmente autenticato, questo non verra\' eliminato. \n Sei sicuro di voler procedere con la cancellazione?');
		}
		setDeleteModalVisible(true);
	}

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const confirmDeleteModal = () => {
		var ids = '';
		selected.filter(id => id !== auth.state.id).forEach(id => ids += id + ',');
		ids = ids.substr(0, ids.length - 1);
		if (!isDelete) {
			auth.state.axiosInstance?.delete('/api/accounts/deactivateAllById/' + ids)
				.then(res => {
					getOperatori();
					setDeleteModalVisible(false);
				})
				.catch(error => {
					toast.error('🛑 Errore durante la disattivazione degli Operatori!');
					console.log(error);
				});
		} else {
			auth.state.axiosInstance?.delete('/api/accounts/deleteAllById/' + ids)
				.then(res => {
					getOperatori();
					setDeleteModalVisible(false);
					toast.success('Operatori eliminati con successo!');
				})
				.catch(error => {
					setDeleteModalVisible(false);
					if (406 === error.response.status) {
						alert.setAlertMessage(error.response.data.message);
						alert.setShowAlert(true);
					} else {
						toast.error('🛑 Errore durante la cancellazione degli Operatori!');
					}
					console.log(error);
				});
		}

	};

	const handleCooperativaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setCooperativaFilter(event.target.value as string);
	};

	const handleOperatoreFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setOperatoreFilter(event.target.value);
	};

	const handleOnlyActivatedClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		setActivatedFilter(event.target.checked);
	}

	const handleSearch = () => {
		getOperatori();
	}

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = operatoreList.map((n) => n.id);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleCheckBoxClick = (event: React.MouseEvent<unknown>, id: string) => {
		const selectedIndex = selected.indexOf(id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleDettaglioClick = (user: UserDTO) => {
		history.push("/dettaglio/operatore/" + user.id);
	};

	const handleRiattivaClick = (user: UserDTO) => {
		auth.state.axiosInstance?.put('/api/accounts/activate_user/' + user.id)
			.then(res => {
				toast.success('Operatore riattivato con successo!');
				getOperatori();
			})
			.catch(error => {
				toast.error('🛑 Errore durante la riattivazione dell\'operatore');
				console.log(error)
			})
	};

	const isSelected = (name: string) => selected.indexOf(name) !== -1;

	return (
		<div>
			<STitleContainer>
				<STitleH3>OPERATORI COOPERATIVA</STitleH3>
			</STitleContainer>
			<SButtonContainer>
				<SButton onClick={handleNewOperatore}><RiAddFill className="mr-2"/>Aggiungi</SButton>
				<SButton onClick={handleDisattivaSelezionati} variant="arancio"
								 disabled={!selected ||
								 selected.length === 0 ||
								 (selected.length === 1 && selected.findIndex((id) => id === auth.state.id) !== -1)}><FaMinusCircle className="mr-2"/>Disattiva</SButton>
				<SButton onClick={handleEliminaSelezionati} variant="rosso"
								 disabled={!selected ||
								 selected.length === 0 ||
								 (selected.length === 1 && selected.findIndex((id) => id === auth.state.id) !== -1)}><FaTrash className="mr-2"/>Elimina</SButton>
				{/*<SButton variant="verde" disabled={!selected || selected.length === 0}><FaFileDownload className="mr-2"/>Esporta</SButton>*/}
			</SButtonContainer>
			<Grid container spacing={0} className="w-100 mb-3">
				{auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 &&
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="cooperativa">Cooperativa</SInputLabel>
						<Select
							required
							labelId="cooperativa"
							id="cooperativaSelect"
							className={classes.selectEmpty}
							label="Cooperativa"
							value={cooperativaFilter}
							onChange={handleCooperativaChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value="ALL" key="ALL">TUTTE</MenuItem>
							{cooperativeList && cooperativeList.map(op => {
								return (
									<MenuItem value={op.id} key={op.id}>{op.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				}
				<Grid item xs={3} className={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? "px-2" : "pr-2"}>
					<TextField
						className="w-100"
						id="operatoreFilter"
						label="Cerca per Nome o Cognome"
						variant="outlined"
						onChange={handleOperatoreFilterChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={2} className="px-2 d-flex justify-content-center">
					<FormControlLabel
						control={<SCheckbox onChange={handleOnlyActivatedClick}
																name="checkedG"
																checked={activatedFilter}/>}
						label="Solo utenti attivi"
					/>
				</Grid>
				<Grid item xs={3} className="pl-2 d-flex align-items-center">
					<SIconButton onClick={handleSearch}><FaSearch className="mx-1"/></SIconButton>
				</Grid>
			</Grid>
			<Paper>
				<TableContainer>
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<STableHeader
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							onSelectAllClick={handleSelectAllClick}
							rowCount={totalRow}
							headCells={headCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{operatoreList &&
							operatoreList
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<STableRow
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													inputProps={{'aria-labelledby': labelId}}
													onClick={(event) => handleCheckBoxClick(event, row.id)}
												/>
											</STableCell>
											<STableCell padding="none">{row.firstname}</STableCell>
											<STableCell padding="none">{row.lastname}</STableCell>
											<STableCell padding="none">{row.email}</STableCell>
											<STableCell padding="none">{row.telefono}</STableCell>
											<STableCell padding="none">{row.cooperativaName}</STableCell>
											<STableCell padding="none" className="text-center">
												{row.activated ?
													<SDialogButton className="w-50" onClick={() => handleDettaglioClick(row)}>Dettaglio</SDialogButton>
													:
													<SDialogButton variantcolor="secondary" className="w-50" onClick={() => handleRiattivaClick(row)}>RIATTIVA</SDialogButton>
												}

											</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[25, 50, 100]}
					component="div"
					count={totalRow}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
					labelRowsPerPage={"Risultati per pagina"}
				/>
			</Paper>
			<ConfirmAlertDialog
				open={deleteModalVisible}
				onCancel={closeDeleteModal}
				onConfirm={confirmDeleteModal}
				message={deleteModalMessage}
			/>
		</div>
	);
}
